import { render, staticRenderFns } from "./withdrawalMaterial.vue?vue&type=template&id=a63a1b36&scoped=true&"
import script from "./withdrawalMaterial.vue?vue&type=script&lang=js&"
export * from "./withdrawalMaterial.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalMaterial.vue?vue&type=style&index=0&id=a63a1b36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63a1b36",
  null
  
)

export default component.exports